import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { PageNotFoundComponent } from "./components/page-not-found/page-not-found.component";
import { PageForbbidenComponent } from "./components/page-forbbiden/page-forbbiden.component";
import { ToastrModule } from "ngx-toastr";
import { ErrorInterceptor } from "./interceptors/error.interceptor";
import { JwtInterceptor } from "./interceptors/jwt.interceptor";
import { DebugService } from "./utilities/others/debug.service";

@NgModule({
  declarations: [PageNotFoundComponent, PageForbbidenComponent],
  imports: [
    CommonModule,
    RouterModule,
    HttpClientModule,
    ToastrModule.forRoot(),
  ],
  exports: [PageNotFoundComponent, PageForbbidenComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
    DebugService,
  ],
})
export class CoreModule {}
